import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { EditButton } from "common/components/EditButton";
import DeleteIcon from "common/icons/DeleteIcon";
import { t } from "i18next";
import React from "react";

interface IConfirmOrCancelDialog {
  open: boolean;
  text: string;
  onClose: () => void;
  onConfirm: () => void;
  confirmIsDelete: boolean;
}

export const ConfirmOrCancelDialog = ({
  open,
  text,
  onClose,
  onConfirm,
  confirmIsDelete,
}: IConfirmOrCancelDialog) => {
  const handleOnClick = () => {
    onConfirm();
    onClose();
  };
  return (
    <Dialog open={open}>
      <DialogContent>
        <DialogTitle>{t("Warning")}</DialogTitle>
        <Typography>{text}</Typography>
      </DialogContent>
      <DialogActions>
        <Button size="large" onClick={onClose} color="primary" variant="text">
          {t("Cancel")}
        </Button>
        {confirmIsDelete ? (
          <EditButton
            icon={<DeleteIcon height={20} />}
            title={t("Delete")}
            iconColor="var(--color-red)"
            onClick={handleOnClick}
          />
        ) : (
          <Button
            size="large"
            onClick={handleOnClick}
            color="primary"
            variant="contained"
          >
            {t("Confirm")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
